import CustomSwiper from '@/_application/core/components/ui/custom-swiper';
import {ImageOptimized} from '@/_application/core/components/ui/image';
import Link from '@/_application/core/components/ui/link';
import {SwiperSlide} from 'swiper/react';
import {convertUrlToNewSite} from '@/_application/core/utils/convert-url';
import {Banner} from '@/__generated__/__types__';
import {getBannerUrlByPath} from '@/_application/helpers/cdn-image';
import {Fragment} from '@kidslabs/mario-nextjs-react-ui-core';

function SubBannerSwiper({subBanner}: {subBanner: Banner[]}) {
    if (!subBanner?.length) {
        return <></>;
    }
    const breakpoints = {
        768: {
            slidesPerView: 2,
            spaceBetween: 16,
        },
        1024: {
            slidesPerView: 3,
            spaceBetween: 20,
        },
    };
    return (
        <div className="min-h-28">
            <CustomSwiper
                className="overflow-hidden!"
                hasNavigation
                autoplay={
                    {
                        // delay: 2500,
                        // disableOnInteraction: false,
                    }
                }
                buttonPrevClassName="-left-4"
                buttonNextClassName="-right-4"
                autoHeight={true}
                breakpoints={breakpoints}>
                {subBanner?.map(banner => {
                    return (
                        <Fragment key={banner?.banner_id}>
                            {banner?.image && (
                                <SwiperSlide key={banner?.banner_id}>
                                    <Link
                                        href={`${convertUrlToNewSite(banner?.url_banner ?? 'javascript:;')}`}
                                        className="w-full transition-opacity hover:opacity-85">
                                        <div className="relative w-full">
                                            <ImageOptimized
                                                width={380}
                                                height={180}
                                                className="rounded-[10px] object-cover"
                                                src={getBannerUrlByPath(banner?.image)}
                                                alt={banner?.name ?? 'Banner'}
                                                loading={'lazy'}
                                            />
                                        </div>
                                    </Link>
                                </SwiperSlide>
                            )}
                        </Fragment>
                    );
                })}
            </CustomSwiper>
        </div>
    );
}

export default SubBannerSwiper;
